export default __webpack_public_path__ + "static/media/folder.ef5a890b.svg";